export const validation = {
  headingMaxChar: 30,
  title: { required: true }
}
